import { Trophy } from "lucide-react";

export default function StpLeaderboard({ entries }) {
  if (!entries) return null;
  return (
    <div className="rounded-lg border border-[#C9A961]/40 bg-[#C9A961]/5 p-3 space-y-2" data-testid="stp-leaderboard">
      <div className="flex items-center gap-2">
        <Trophy className="w-4 h-4 text-[#8A6D1F]" aria-hidden="true" />
        <h3 className="text-xs font-semibold uppercase tracking-wider text-[#0A1F44]">STP Run — MG1 Top 10</h3>
      </div>
      {entries.length === 0 ? (
        <p className="text-xs text-slate-500" data-testid="stp-leaderboard-empty">No completed MG1s in the run yet — the first one puts you on the board.</p>
      ) : (
        <ol className="divide-y divide-slate-100" data-testid="stp-leaderboard-list">
          {entries.map((e, i) => (
            <li key={i} className="flex items-center gap-3 py-1.5 text-sm cursor-default select-text" data-testid={`stp-leaderboard-row-${i}`}>
              <span className={`w-7 h-7 shrink-0 rounded-full flex items-center justify-center text-xs font-semibold ${e.rank <= 3 ? "bg-[#0A1F44] text-[#C9A961]" : "bg-slate-100 text-slate-600"}`}
                data-testid={`stp-leaderboard-rank-${i}`}>{e.rank}</span>
              <span className="text-[#0A1F44] truncate" data-testid={`stp-leaderboard-name-${i}`}>{e.name}</span>
            </li>
          ))}
        </ol>
      )}
      <p className="text-[10px] text-slate-500">Ranked by completed personal MG1s since 1 Nov. Equal totals share a rank.</p>
    </div>
  );
}
